import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store";
import { createAppTheme } from "./theme";
import { ColorModeContext } from "./colorMode";
import "./index.css";
import "./i18n";

const getInitialMode = () => {
  if (typeof window === "undefined") return "light";
  const stored = window.localStorage.getItem("rss-energie-color-mode");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

// eslint-disable-next-line react-refresh/only-export-components
const Root = () => {
  const [mode, setMode] = useState<"light" | "dark">(getInitialMode);
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    window.localStorage.setItem("rss-energie-color-mode", mode);
  }, [mode]);

  return (
    <React.StrictMode>
      <Provider store={store}>
        <ColorModeContext.Provider
          value={{ mode, toggleMode: () => setMode((prev) => (prev === "light" ? "dark" : "light")) }}
        >
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </ColorModeContext.Provider>
      </Provider>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(<Root />);
